export default __webpack_public_path__ + "static/media/express-deliveries.264c6722.svg";